// Toplam tutar satırı.
import useCommon from "@/shared/hooks/useCommon";
import {
  useHasOrders,
  useHasSession,
  useSessionTotalAmount,
} from "@/shared/hooks/usePosOrderTableSessionHook";
import { formatPrice } from "@/shared/utils/helpers";
import PosRow from "./PosRow";

const PosCartTotal = ({ total }: { total: number }) => {
  const hasSession = useHasSession();
  const hasOrders = useHasOrders();
  const sessionTotalAmount = useSessionTotalAmount();
  const t = useCommon();
  return (
    <PosRow fontWeight="bold" label={t("posOrders.total")}>
      {formatPrice(hasSession && hasOrders ? sessionTotalAmount : total)}
    </PosRow>
  );
};

export default PosCartTotal;
